var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBeatBreadCirclePulse = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ej9wCqxNlRV1",
    viewBox: "0 0 60 61",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/2000/svg"
  }, "#ej9wCqxNlRV4{animation:vR1oN7gX 1.5s .1s infinite ease-in-out}@keyframes vR1oN7gX{0%{opacity:0;transform:translate(30px,30.9941px) scale(.75)}20%{opacity:1}100%{opacity:0;transform:translate(30px,30.9941px) scale(1)}}#ej9wCqxNlRV5{animation:j4K9wPmL 1.5s infinite cubic-bezier(0,.55,.45,1),qS8zYhT3 1.5s infinite ease-in-out}@keyframes j4K9wPmL{0%{transform:translate(30.000001px,30.9946px) scale(.6)}15%{transform:translate(30.000001px,30.9946px) scale(.7)}40%{transform:translate(30.000001px,30.9946px) scale(.6)}100%{transform:translate(30.000001px,30.9946px) scale(.6)}}#ej9wCqxNlRV6{animation:j4K9wPmL-b 1.5s infinite cubic-bezier(0,.55,.45,1)}@keyframes j4K9wPmL-b{0%{transform:translate(12px,12.2px) scale(.6)}15%{transform:translate(9px,9.2px) scale(.7)}40%{transform:translate(12px,12.2px) scale(.6)}100%{transform:translate(12px,12.2px) scale(.6)}}@keyframes qS8zYhT3{0%{opacity:.5}20%{opacity:1}100%{opacity:.5}}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    clipPath: "url(#ej9wCqxNlRV7)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "ej9wCqxNlRV4",
    r: 30,
    opacity: 0,
    fill: "#cdc8e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ej9wCqxNlRV5",
    r: 23.2759,
    opacity: 0.5,
    fill: "#594aa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ej9wCqxNlRV6",
    d: "M31.9667,47.046h-10.8539v-32.1046h5.9091v21.1632c.0455,2.1648,1.837,3.883,4.0018,3.8375c2.1647-.0455,3.8829-1.8371,3.8374-4.0018-.045-2.1328-1.7865-3.8379-3.9194-3.8384-.851,0-1.6777.2811-2.3518.8004v-17.9609h3.799c4.0276.043,7.2577,3.3419,7.2158,7.3689.0065,2.099-.8764,4.1019-2.4297,5.5132c3.0734,1.9003,4.9377,5.2619,4.9225,8.8753.0597,5.6548-4.476,10.2871-10.1308,10.3472Z",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBeatBreadCirclePulse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/beatBread-circle-pulse.b23fb096.svg";
export { ForwardRef as ReactComponent };